module.exports = __webpack_public_path__ + "static/media/mosart.f5af70be.png";